module.exports = __webpack_public_path__ + "img/calendar-grey-main.9fd55792.svg";